
/*

Dependancies: _goooglemaps.scss, json-settings/googlemaps/*.json

<div class='googlemap'>
    <div class='googlemap__inner'>
        <div class='googlemap__map js-googlemap'
            data-marker-url='<?php bloginfo('template_directory'); ?>/build/img/map-marker.png'
            data-map-settings='<?php bloginfo('template_directory'); ?>/json-settings/googlemaps/googlemaps-1.json'>              
        </div>
    </div>
</div>


You can add multiple maps by creating more map.json files, and linking to them
via the data-map-settings data-attribute on the maps HTML.

You can add multiple markers to any map by appending to the locations array within
the maps corresponding map.json file.

*/

WW.googlemaps = function($) {
    'use strict';    

    const createMap = (googlemap) => {
        const jsonLocation = googlemap.getAttribute('data-map-settings');
        let map;
        $.getJSON(jsonLocation)
            .done(data => {
                initialize(data.map);
            }).fail(err => {
                console.warn('Possible error in JSON file or not loaded. \nError: ' + err);
            });
        const initialize = mapConfig => {

            const latLang = new google.maps.LatLng(mapConfig.mapParams.longitude, 
                    mapConfig.mapParams.latitude),
                MY_MAPTYPE_ID = 'custom_style';
            let featureOpts,
                mapOptions,
                styledMapOptions,
                customMapType;

            mapOptions = {
                center: latLang,
                zoom: mapConfig.mapParams.zoom,
                draggable: true,
                scrollwheel: false,
                panControl: false,
                mapTypeControl: false,
                zoomControl: true,
                streetViewControl: true,
                mapTypeControlOptions: {
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
                },
                mapTypeId: MY_MAPTYPE_ID
            };

            featureOpts = [{'featureType':'administrative.province','elementType':'geometry.stroke','stylers':[{'visibility':'on'},{'color':'#d78a3a'},{'gamma':'1.61'},{'lightness':'10'},{'weight':'1.20'}]},{'featureType':'administrative.province','elementType':'labels.text.fill','stylers':[{'color':'#b78653'}]},{'featureType':'administrative.locality','elementType':'all','stylers':[{'visibility':'off'}]},{'featureType':'landscape.natural','elementType':'all','stylers':[{'hue':'#ffbb00'},{'saturation':54}]},{'featureType':'poi','elementType':'labels','stylers':[{'saturation':-84},{'lightness':6},{'visibility':'off'}]},{'featureType':'poi.attraction','elementType':'all','stylers':[{'saturation':-55}]},{'featureType':'poi.park','elementType':'all','stylers':[{'visibility':'on'},{'saturation':-60},{'gamma':1.91}]},{'featureType':'poi.park','elementType':'labels','stylers':[{'visibility':'off'}]},{'featureType':'road','elementType':'all','stylers':[{'visibility':'simplified'},{'saturation':-27},{'gamma':1.8}]},{'featureType':'road.highway','elementType':'geometry','stylers':[{'hue':'#ff8800'},{'saturation':-79},{'lightness':-16},{'visibility':'simplified'}]},{'featureType':'road.highway','elementType':'labels','stylers':[{'saturation':-67},{'hue':'#ff9900'},{'lightness':6},{'visibility':'off'}]},{'featureType':'road.arterial','elementType':'geometry','stylers':[{'hue':'#ff6600'},{'saturation':-75},{'lightness':-21}]},{'featureType':'road.arterial','elementType':'labels','stylers':[{'saturation':-79},{'visibility':'off'}]},{'featureType':'road.local','elementType':'all','stylers':[{'hue':'#ff5e00'},{'saturation':-24},{'visibility':'simplified'},{'lightness':28}]},{'featureType':'road.local','elementType':'labels','stylers':[{'visibility':'on'}]},{'featureType':'transit.line','elementType':'all','stylers':[{'visibility':'simplified'},{'saturation':-27}]},{'featureType':'transit.station','elementType':'all','stylers':[{'visibility':'off'}]},{'featureType':'water','elementType':'all','stylers':[{'visibility':'on'},{'saturation':-85}]}];


            styledMapOptions = {
                name: 'Custom Style'
            };

            customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);
            map = new google.maps.Map(googlemap,mapOptions);
            map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

            if (WW.isTouch) {
                map.setOptions({
                    draggable: false
                });
            }
            
            mapConfig.locations.forEach(createMarker);
        };

        const createMarker = location => {
            let infowindow = new google.maps.InfoWindow(),
                longitude = location.longitude,
                latitude = location.latitude,
                imageLocation = googlemap.getAttribute('data-marker-url'),
                image,
                marker;

            image = new google.maps.MarkerImage(imageLocation,
                // This marker is 21 pixels wide by 30 pixels tall.
                new google.maps.Size(20, 30),
                // The origin for this image is 0,0.
                new google.maps.Point(0,0),
                // The anchor for this image is the base of the flagpole at 18,42.
                new google.maps.Point(10, 30)
            );

            marker = new google.maps.Marker({
                map: map,
                position: {
                    lat: longitude, 
                    lng: latitude
                },
                visible: true,
                icon: image // This path is the custom pin to be shown. Remove this line and the proceeding comma to use default pin
            });

            infowindow.setContent(`
                <div class="info-window-hook">
                    <div> 
                        <strong>${location.headline}</strong> 
                    </div>
                    <div> 
                        ${location.bodyText} 
                    </div>
                </div>
            `);

            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open(map, this);
            });
        };
    };

    const maps = document.querySelectorAll('.js-googlemap');
    [].forEach.call(maps, map => {
        createMap(map);
    });
    
    return this;
};

// add .googlemaps($) to main.js